import React, {useState, useEffect, Fragment} from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  Button,
} from "reactstrap";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ui_helpers } from "../../helpers";
import { constants } from "../../utils";
import { default as useContractStore } from "./utils/useContractStore";
import {DebounceInput} from "react-debounce-input";
import classnames from 'classnames';
import Select from 'react-select';

export default function CustomerInformation2() {
  // let initialContactCount = 2;
  // while(defaultCustomer[`contact${initialContactCount}LastName`] !== undefined) {
  //   initialContactCount++;
  // }
  // const [contactCount, setContactCount] = useState(initialContactCount-1);
  const contactCount = useContractStore(x => x.contactCount);
  const setContactCount = useContractStore(x => x.setContactCount);
  const screenWarnings = useContractStore(x => x.screenWarnings);
  const additionalContactData = useContractStore(x => x.additionalContactData);
  const setAdditionalContactData = useContractStore(x => x.setAdditionalContactData);
  const propertyOwner = useContractStore(x => x.propertyOwner);
  const setPropertyOwner = useContractStore(x => x.setPropertyOwner);
  const landOwnerEmail = useContractStore(x => x.landOwnerEmail);
  const setLandOwnerEmail = useContractStore(x => x.setLandOwnerEmail);
  const landOwnerPhone = useContractStore(x => x.landOwnerPhone);
  const setLandOwnerPhone = useContractStore(x => x.setLandOwnerPhone);
  const landOwnerFirstName = useContractStore(x => x.landOwnerFirstName);
  const setLandOwnerFirstName = useContractStore(x => x.setLandOwnerFirstName);
  const landOwnerLastName = useContractStore(x => x.landOwnerLastName);
  const setLandOwnerLastName = useContractStore(x => x.setLandOwnerLastName);
  const landOwnerAddress1 = useContractStore(x => x.landOwnerAddress1);
  const setLandOwnerAddress1 = useContractStore(x => x.setLandOwnerAddress1);
  const landOwnerAddress2 = useContractStore(x => x.landOwnerAddress2);
  const setLandOwnerAddress2 = useContractStore(x => x.setLandOwnerAddress2);
  const landOwnerCity = useContractStore(x => x.landOwnerCity);
  const setLandOwnerCity = useContractStore(x => x.setLandOwnerCity);
  const landOwnerState = useContractStore(x => x.landOwnerState);
  const setLandOwnerState = useContractStore(x => x.setLandOwnerState);
  const landOwnerZip = useContractStore(x => x.landOwnerZip);
  const setLandOwnerZip = useContractStore(x => x.setLandOwnerZip);
  const employmentTypes = useContractStore(x => x.employmentTypes);
  const employmentType = useContractStore(x => x.employmentType);
  const setEmploymentType = useContractStore(x => x.setEmploymentType);
  const employerName = useContractStore(x => x.employerName);
  const setEmployerName = useContractStore(x => x.setEmployerName);
  const employerPhone = useContractStore(x => x.employerPhone);
  const setEmployerPhone = useContractStore(x => x.setEmployerPhone);
  const corenterFirstName = useContractStore(x => x.corenterFirstName);
  const setCorenterFirstName = useContractStore(x => x.setCorenterFirstName);
  const corenterLastName = useContractStore(x => x.corenterLastName);
  const setCorenterLastName = useContractStore(x => x.setCorenterLastName);
  const corenterAddress1 = useContractStore(x => x.corenterAddress1);
  const setCorenterAddress1 = useContractStore(x => x.setCorenterAddress1);
  const corenterAddress2 = useContractStore(x => x.corenterAddress2);
  const setCorenterAddress2 = useContractStore(x => x.setCorenterAddress2);
  const corenterCity = useContractStore(x => x.corenterCity);
  const setCorenterCity = useContractStore(x => x.setCorenterCity);
  const corenterState = useContractStore(x => x.corenterState);
  const setCorenterState = useContractStore(x => x.setCorenterState);
  const corenterZip = useContractStore(x => x.corenterZip);
  const setCorenterZip = useContractStore(x => x.setCorenterZip);
  const corenterDateOfBirth = useContractStore(x => x.corenterDateOfBirth);
  const setCorenterDateOfBirth = useContractStore(x => x.setCorenterDateOfBirth);
  const dateOfBirth = useContractStore(x => x.dateOfBirth);
  const corenterPhone = useContractStore(x => x.corenterPhone);
  const setCorenterPhone = useContractStore(x => x.setCorenterPhone);
  const corenterEmail = useContractStore(x => x.corenterEmail);
  const setCorenterEmail = useContractStore(x => x.setCorenterEmail);

  const [hasCorenter, setHasCorenter] = useState(corenterLastName ? true : false);
  const [corenterDateOfBirthText, setCorenterDateOfBirthText] = useState(corenterDateOfBirth);

  useEffect(() => {
    setCorenterDateOfBirthText(corenterDateOfBirth);
  }, [corenterDateOfBirth])

  // useEffect(() => {
  //   let initialContactCount = 2;
  //   while(defaultCustomer[`contact${initialContactCount}LastName`] !== undefined) {
  //     initialContactCount++;
  //   }
  //   setContactCount(initialContactCount-1);
  // }, [])

  function onChangeContactData(idx, suffix, value) {
    let newData = { ...additionalContactData };
    newData[`contact${idx}${suffix}`] = value;
    setAdditionalContactData(newData);
  }

  return (
    <Form className="mt-2">
      <Row>
        <Col>
          <div
            className='mb-1'
            style={{cursor: "pointer"}}
            onClick={(e) => {
              e.stopPropagation();
              setPropertyOwner(!propertyOwner);
            }}
          >
            <Input
              type="checkbox"
              checked={propertyOwner}
              onChange={(e) => {
                e.stopPropagation();
                setPropertyOwner(!propertyOwner);
              }}
            />{" "}
            Property Owner
          </div>
          {propertyOwner ? null : (
            <>
              <div className="mb-2">
                <Label>
                  Landowner Details
                </Label>
                <Row>
                  <Col xs="1"><div className="star-box">{ui_helpers.requiredStar()}</div></Col>
                  <Col>
                    <DebounceInput
                      type="text"
                      min={1}
                      title={screenWarnings.landOwnerFirstName ? screenWarnings.landOwnerFirstName : null}
                      className={classnames({invalid: (screenWarnings.landOwnerFirstName ? true : false)}, "form-control-sm form-control")}
                      debounceTimeout={300}
                      style={{width: "90%"}}
                      value={landOwnerFirstName}
                      maxLength="25"
                      placeholder="Landowner First Name"
                      autoComplete="false"
                      onChange={(e) => setLandOwnerFirstName(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="mb-2">
                <Row>
                  <Col xs="1"><div className="star-box">{ui_helpers.requiredStar()}</div></Col>
                  <Col>
                    <DebounceInput
                      type="text"
                      min={1}
                      title={screenWarnings.landOwnerLastName ? screenWarnings.landOwnerLastName : null}
                      className={classnames({invalid: (screenWarnings.landOwnerLastName ? true : false)}, "form-control-sm form-control")}
                      debounceTimeout={300}
                      style={{width: "90%"}}
                      value={landOwnerLastName}
                      maxLength="25"
                      placeholder="Landowner Last Name"
                      autoComplete="false"
                      onChange={(e) => setLandOwnerLastName(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="mb-1">
                <Row>
                  <Col xs="1"><div className="star-box">{ui_helpers.requiredStar()}</div></Col>
                  <Col>
                    <DebounceInput
                      type="text"
                      min={1}
                      title={screenWarnings.landOwnerAddress1 ? screenWarnings.landOwnerAddress1 : null}
                      className={classnames({invalid: (screenWarnings.landOwnerAddress1 ? true : false)}, "form-control-sm form-control")}
                      debounceTimeout={600}
                      style={{width: "90%"}}
                      value={landOwnerAddress1}
                      maxLength="100"
                      placeholder="Landowner Address 1"
                      autoComplete="false"
                      onChange={(e) => setLandOwnerAddress1(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="mb-1">
                <Row>
                  <Col xs="1"><div className="star-box mr-4" ></div></Col>
                  <Col>
                    <DebounceInput
                      type="text"
                      min={1}
                      title={screenWarnings.landOwnerAddress2 ? screenWarnings.landOwnerAddress2 : null}
                      className={classnames({invalid: (screenWarnings.landOwnerAddress2 ? true : false)}, "form-control-sm form-control")}
                      debounceTimeout={300}
                      style={{width: "90%"}}
                      value={landOwnerAddress2}
                      maxLength="100"
                      placeholder="Landowner Address 2 (optional)"
                      autoComplete="false"
                      onChange={(e) => setLandOwnerAddress2(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="mb-2">
                <Row>
                  <Col xs="1"><div className="star-box">{ui_helpers.requiredStar()}</div></Col>
                  <Col>
                    <Row>
                      <Col>
                        <DebounceInput
                          type="text"
                          min={1}
                          title={screenWarnings.landOwnerCity ? screenWarnings.landOwnerCity : null}
                          className={classnames({invalid: (screenWarnings.landOwnerCity ? true : false)}, "form-control-sm form-control")}
                          debounceTimeout={300}
                          style={{float: "left", width: "45%"}}
                          value={landOwnerCity}
                          maxLength="50"
                          placeholder="City"
                          autoComplete="false"
                          onChange={(e) => setLandOwnerCity(e.target.value)}
                        />
                        <DebounceInput
                          type="text"
                          min={1}
                          title={screenWarnings.landOwnerState ? screenWarnings.landOwnerState : null}
                          className={classnames({invalid: (screenWarnings.landOwnerState ? true : false)}, "form-control-sm form-control")}
                          debounceTimeout={300}
                          style={{float: "left", width: "2.3rem", marginLeft: "2px"}}
                          value={landOwnerState}
                          maxLength="2"
                          placeholder="ST"
                          autoComplete="false"
                          onChange={(e) => setLandOwnerState(e.target.value)}
                        />
                        <DebounceInput
                          type="text"
                          min={1}
                          title={screenWarnings.landOwnerZip ? screenWarnings.landOwnerZip : null}
                          className={classnames({invalid: (screenWarnings.landOwnerZip ? true : false)}, "form-control-sm form-control")}
                          debounceTimeout={300}
                          style={{float: "left", width: "4rem", marginLeft: "2px"}}
                          value={landOwnerZip}
                          maxLength="20"
                          placeholder="Zip"
                          autoComplete="false"
                          onChange={(e) => setLandOwnerZip(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="mb-2">
                <Row>
                  <Col xs="1">
                    <div className="star-box">{ui_helpers.requiredStar()}</div>
                  </Col>
                  <Col>
                    <DebounceInput
                      type="tel"
                      min={1}
                      style={{width: "90%"}}
                      placeholder="Landowner Phone"
                      maxLength="20"
                      className={classnames({invalid: (screenWarnings.landOwnerPhone ? true : false)}, "form-control-sm form-control")}
                      title={screenWarnings.landOwnerPhone ? screenWarnings.landOwnerPhone : null}
                      debounceTimeout={500}
                      value={landOwnerPhone}
                      autoComplete="false"
                      onChange={(e) => setLandOwnerPhone(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
              <div className="mb-2">
                <Row>
                  <Col xs="1">
                    <div className="star-box mr-4" ></div>
                  </Col>
                  <Col>
                    <Input type="email" placeholder="Landowner Email" bsSize="sm" maxLength="150" style={{width: "90%"}}
                      value={landOwnerEmail} onChange={(e) => setLandOwnerEmail(e.target.value)} />
                  </Col>
                </Row>
              </div>
            </>
          )}
        </Col>
        <Col className="form-col-even">
          <div className="mb-2">
            <Label>
              Employment Type {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.employmentType ? screenWarnings.employmentType : null}>
              <Select
                options={employmentTypes}
                classNamePrefix={screenWarnings.employmentType ? "invalidSelect" : null}
                value={employmentType}
                onChange={(x) => setEmploymentType(x)}
              />
            </div>
          </div>
          {employmentType && constants.EMPLOYMENT_TYPES_REQUIRING_EMPLOYER.includes(employmentType.label)
            ? (<Fragment>
                <div className="mb-2">
                  <Label>Employer Details</Label>
                  <Row>
                    <Col xs='1'><div className="star-box">{ui_helpers.requiredStar()}</div></Col>
                    <Col>
                      <Input type="text" bsSize="sm" placeholder="Business Name" 
                        title={screenWarnings.employerName ? screenWarnings.employerName : null}
                        className={classnames({invalid: (screenWarnings.employerName ? true : false)})}
                        value={employerName} maxLength="100" onChange={(e) => setEmployerName(e.target.value)} />
                    </Col>
                  </Row>
                </div>
                <div className="mb-2">
                  <Row>
                    <Col xs="1">
                      <div className="star-box mr-4" ></div>
                    </Col>
                    <Col>
                      <DebounceInput
                        type="text"
                        min={1}
                        placeholder="Business Phone"
                        maxLength="20"
                        className="form-control form-control-sm"
                        debounceTimeout={300}
                        value={employerPhone}
                        autoComplete="false"
                        onChange={(e) => setEmployerPhone(e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>
              </Fragment>)
            : null
          }
        </Col>
        <Col>
          {_.map(_.range(1, contactCount + 1), cidx => {
            const starBox = (<div className="star-box">{cidx === 1 ? ui_helpers.requiredStar() : <span>&nbsp;</span>}</div>);
            return (<div key={cidx}>
              <Label>
                Additional Contact {cidx}
              </Label>
              <div className="mb-1">
                {starBox}
                <Input type="text" bsSize="sm" style={{width: "90%"}} placeholder="First Name" maxLength="25" 
                  title={screenWarnings[`contact${cidx}FirstName`] ? screenWarnings[`contact${cidx}FirstName`] : null}
                  className={classnames({invalid: (screenWarnings[`contact${cidx}FirstName`] ? true : false)})}
                  value={additionalContactData[`contact${cidx}FirstName`]}
                  onChange={(e) => onChangeContactData(cidx, 'FirstName', ui_helpers.capitalizeFirstLetter(e.target.value))} />
              </div>
              <div className="mb-1">
                {starBox}
                <Input type="text" bsSize="sm" style={{width: "90%"}} placeholder="Last Name" maxLength="25" 
                  title={screenWarnings[`contact${cidx}LastName`] ? screenWarnings[`contact${cidx}LastName`] : null}
                  className={classnames({invalid: (screenWarnings[`contact${cidx}LastName`] ? true : false)})}
                  value={additionalContactData[`contact${cidx}LastName`]}
                  onChange={(e) => onChangeContactData(cidx, 'LastName', ui_helpers.capitalizeFirstLetter(e.target.value))} />
              </div>
              <div className="mb-1">
                {starBox}
                <DebounceInput
                  type="text"
                  min={1}
                  style={{width: "90%"}}
                  placeholder="Phone"
                  maxLength="20" 
                  title={screenWarnings[`contact${cidx}Phone`] ? screenWarnings[`contact${cidx}Phone`] : null}
                  className={classnames({invalid: (screenWarnings[`contact${cidx}Phone`] ? true : false)}, "form-control-sm form-control")}
                  debounceTimeout={500}
                  value={additionalContactData[`contact${cidx}Phone`]}
                  autoComplete="false"
                  onChange={(e) => onChangeContactData(cidx, 'Phone', ui_helpers.formatPhoneField(e.target.value))}
                />
              </div>
              <div className="mb-1">
                <div className="star-box">&nbsp;</div>
                <Input type="text" bsSize="sm" style={{width: "90%"}} placeholder="Email (Optional)" maxLength="150" 
                  title={screenWarnings[`contact${cidx}Email`] ? screenWarnings[`contact${cidx}Email`] : null}
                  className={classnames({invalid: (screenWarnings[`contact${cidx}Email`] ? true : false)})}
                  value={additionalContactData[`contact${cidx}Email`]}
                  onChange={(e) => onChangeContactData(cidx, 'Email', e.target.value)} />
              </div>
              <div className="mb-1">
                {starBox}
                <Input type="text" bsSize="sm" style={{width: "90%"}} placeholder="Relationship" maxLength="100" 
                  title={screenWarnings[`contact${cidx}Relationship`] ? screenWarnings[`contact${cidx}Relationship`] : null}
                  className={classnames({invalid: (screenWarnings[`contact${cidx}Relationship`] ? true : false)})}
                  value={additionalContactData[`contact${cidx}Relationship`]}
                  onChange={(e) => onChangeContactData(cidx, 'Relationship', e.target.value)} />
              </div>
            </div>)})}
          <Button color="info" className="float-end text-light mb-1" size="sm" onClick={() => setContactCount(contactCount + 1)}>
            <FontAwesomeIcon icon='plus' /> Add Additional Contact
          </Button>
        </Col>
        <Col className="form-col-even">
          <Row>
            <Col>
              {hasCorenter
                ? (<Fragment>
                    <Button color="danger" className="text-light" size="sm" onClick={() => setHasCorenter(false)}>
                      Remove Corenter
                    </Button>
                    <div className="mt-2">
                      <Label>
                        Corenter Details
                      </Label>
                    </div>
                    <div className="mb-1">
                      <Input type="text" bsSize="sm" maxLength="25" autoComplete="off" placeholder="Corenter First Name" 
                        title={screenWarnings.corenterFirstName ? screenWarnings.corenterFirstName : null}
                        className={classnames({invalid: (screenWarnings.corenterFirstName ? true : false)})}
                        value={corenterFirstName}
                        onChange={(e) => setCorenterFirstName(ui_helpers.capitalizeFirstLetter(e.target.value))} />
                    </div>
                    <div className="mb-1">
                      <Input type="text" bsSize="sm" maxLength="25" autoComplete="off" placeholder="Corenter Last Name"
                        value={corenterLastName} 
                        onChange={(e) => setCorenterLastName(ui_helpers.capitalizeFirstLetter(e.target.value))} />
                    </div>
                    <div className="mb-1">
                      <Input type="text" bsSize="sm" maxLength="100" placeholder="Corenter Address 1" 
                        value={corenterAddress1}
                        onChange={(e) => setCorenterAddress1(e.target.value)} />
                    </div>
                    <div className="mb-1">
                      <Input
                        type="text"
                        bsSize="sm"
                        maxLength="100"
                        placeholder="Corenter Address 2 (optional)"
                        value={corenterAddress2}
                        onChange={(e) => setCorenterAddress2(e.target.value)} 
                      />
                    </div>
                    <div>
                      <Row>
                        <Col xs={6}>
                          <Input bsSize="sm" maxLength="50" type="text" placeholder="City" value={corenterCity} 
                            onChange={(e) => setCorenterCity(ui_helpers.capitalizeFirstLetter(e.target.value))} />
                        </Col>
                        <Col xs={2}>
                          <Input bsSize="sm" maxLength="2" type="text" placeholder="ST" value={corenterState} 
                            onChange={(e) => setCorenterState(ui_helpers.capitalizeAllLetters(e.target.value))} />
                        </Col>
                        <Col xs={4}>
                          <Input bsSize="sm" maxLength="20" type="text" placeholder="Zip" value={corenterZip}
                            onChange={(e) => setCorenterZip(e.target.value)} />
                        </Col>
                      </Row>
                    </div>
                    <div className="mb-2">
                      <Label>
                        Corenter Date of Birth
                      </Label>
                      <DebounceInput
                        type="text"
                        min={1}
                        title={screenWarnings.corenterDateOfBirth ? screenWarnings.corenterDateOfBirth : null}
                        className={classnames({invalid: (screenWarnings.corenterDateOfBirth ? true : false)}, "form-control-sm form-control")}
                        debounceTimeout={300}
                        value={corenterDateOfBirthText}
                        autoComplete="false"
                        onChange={(e) => setCorenterDateOfBirthText(e.target.value)}
                        onBlur={(e) => setCorenterDateOfBirth(e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <Label>Corenter Phone</Label>
                      <DebounceInput
                        type="tel"
                        min={1}
                        title={screenWarnings.corenterPhone ? screenWarnings.corenterPhone : null}
                        className={classnames({invalid: (screenWarnings.corenterPhone ? true : false)}, "form-control-sm form-control")}
                        debounceTimeout={300}
                        maxLength="20"
                        value={corenterPhone}
                        autoComplete="false"
                        onChange={(e) => setCorenterPhone(e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <Label>Corenter Email</Label>
                      <Input
                        type="email"
                        bsSize="sm"
                        maxLength="150" 
                        title={screenWarnings.corenterEmail ? screenWarnings.corenterEmail : null}
                        className={classnames({invalid: (screenWarnings.corenterEmail ? true : false)})}
                        value={corenterEmail}
                        onChange={(e) => setCorenterEmail(e.target.value)}
                      />
                    </div>
                   </Fragment>)
                : (<Button color="dark" size="sm" onClick={() => setHasCorenter(true)}>
                    Add Corenter
                  </Button>)
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};